import React from 'react';
import PopupContainer from '../../../common/components/PopupContainer';
import CustomButton from '../../../common/components/CustomButton';

export default function MusicEditDisabledPopup({
  onClose,
} : {
  onClose: () => void,
}) {

  return (
    <PopupContainer title="曲情報の編集" onClose={() => { onClose(); }}>
      <div className="list__body">
        <p>
          この曲を収録したリリースがあるため、このページで編集・削除ができません。「
          <a href="/music_albums">音楽配信の管理</a>
          」ページで修正や削除を行ってください。
        </p>
        <p className="top_line" />
        <ul>
          <li className="bt">
            <CustomButton type="cancel" onClick={() => onClose()}>戻る</CustomButton>
          </li>
        </ul>
      </div>
    </PopupContainer>
  );
}
